export const projectData = {
  title: {
    mainTitle: "PORTFOLIO",
    heading: "Recent Projects",
  },
  projects: [
    {
      title: "Cost-Effective Solutions",
      image:"/projects/project1.png",
    },
    {
      title: "Advanced Technology",
      image:"/projects/project2.png",
    },
    {
      title: "Customizable Solutions",
      image:"/projects/project5.jpg",
    },
    {
      title: "Customizable Solutions",
      image:"/projects/project3.png",
    },
    {
      title: "Customizable Solutions",
      image:"/projects/project4.png",
    },
  ],
};